import { extractScopeFromUrlString } from '#context/file-contexts-common';
import { FILE_PREVIEW_FILE_ENDPOINT, FILE_PREVIEW_HTML_FILE_NAME, FilePreviewUrlSearchParams, } from '../../constants';
// To be used when generating URLs for the iframe / direct requests for files
// to the SW. If request will not be direct, we request the micro frontend html,
// otherwise directly request the file.
export const getFileRequestUrl = ({ fsEntryExtension, fsEntryId, fsEntryName, fsEntrySize, scope, shouldMakeDirectRequest = true, }) => {
    const params = new URLSearchParams({
        [FilePreviewUrlSearchParams.FsEntryId]: fsEntryId,
        [FilePreviewUrlSearchParams.FsEntryName]: fsEntryName,
        [FilePreviewUrlSearchParams.FsEntrySize]: fsEntrySize.toString(),
        [FilePreviewUrlSearchParams.FsEntryExtension]: fsEntryExtension,
    });
    return `/${scope}/${shouldMakeDirectRequest ? FILE_PREVIEW_FILE_ENDPOINT : FILE_PREVIEW_HTML_FILE_NAME}?${params.toString()}`;
};
// To be used when parsing requests in the SW
export const parseFileRequestUrl = (urlString) => {
    const url = new URL(urlString);
    const scope = extractScopeFromUrlString(urlString);
    const { searchParams } = url;
    const fsEntryId = searchParams.get(FilePreviewUrlSearchParams.FsEntryId);
    const fsEntryName = searchParams.get(FilePreviewUrlSearchParams.FsEntryName);
    const fsEntrySize = searchParams.get(FilePreviewUrlSearchParams.FsEntrySize);
    const fsEntryExtension = searchParams.get(FilePreviewUrlSearchParams.FsEntryExtension);
    if (!fsEntryId || !fsEntryName || !fsEntrySize || !fsEntryExtension) {
        return null;
    }
    let fsEntrySizeBigInt;
    try {
        fsEntrySizeBigInt = BigInt(fsEntrySize);
    }
    catch (e) {
        return null;
    }
    // See if you actually need decoding here
    return {
        fsEntryId,
        fsEntryName,
        fsEntrySize: fsEntrySizeBigInt,
        fsEntryExtension,
        scope,
    };
};
